import React, { Component, Fragment, createRef } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'
import * as R from 'ramda'
import Panel from '../../../../UniformComponents/Panel'
import Button from '../../../../UniformComponents/Button'
import Typography from '../../../../UniformComponents/Typography'
import './presentation-layout.scss'

const LEFT_PANEL_FROM_TOP_CLEARANCE = 120
const LEFT_PANEL_FROM_BOTTOM_CLEARANCE = 60
@observer
class PresentationLayout extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showFilterPanel: (!!props?.hideFilterAccordion || window.innerWidth > 992),
            showGuideAccordion: false,
            showBottomScroller: false,
        }
        this.presentationPanelRef = createRef()
        this.tableRef = createRef()
        this.rightContainerRef = createRef()
        this.innerContainerRef = createRef()

        this.leftPanelRef = React.createRef()
        this.scrollableDivRef = React.createRef()
        this.scrollableWrapperRef = React.createRef()
        this.resetWrapperRef = React.createRef()

        this.leftPanelObserver = null
    }

    componentDidMount() {
        window.addEventListener('resize', this.checkOverflow)
    }

    checkOverflow = () => {
        const { innerWidth } = window
        if (innerWidth > 992) {
            this.setState({ showFilterPanel: true })
        } else this.setState({ showFilterPanel: !!this.props.hideFilterAccordion || false })
    }

    setLeftPanelHeight = () => {
        const screenHeight = window.innerHeight
        const leftPanel = this.leftPanelRef.current
        const newLeftPanelHeight = screenHeight - (
            LEFT_PANEL_FROM_TOP_CLEARANCE + LEFT_PANEL_FROM_BOTTOM_CLEARANCE)

        // eslint-disable-next-line no-param-reassign
        // leftPanel.style.height = `${newLeftPanelHeight}px`
        // this.checkOverflowLeftPanel()
    }

    handleScroll = () => {
        const scrollableElement = this.scrollableDivRef.current
        scrollableElement.scrollTop += 60
    }

    toggleFilterPanel = () => {
        this.setState((prevState) => ({
            showFilterPanel: !prevState.showFilterPanel,
        }))
    }

    toggleGuide = () => {
        this.setState((prevState) => ({
            showGuideAccordion: !prevState.showGuideAccordion,
        }))
    }

    renderPageTitle = (pageTitle, showFilterPanel, hideFilterAccordion) => (
        <div
            className="heading"
            onClick={(e) => {
                !hideFilterAccordion ? this.toggleFilterPanel() : () => {}
            }}
            aria-hidden
        >
            {!hideFilterAccordion && (
                <Fragment>
                    <Typography type="h3">Global Settings</Typography>

                    <i className={`panel-toggle-icon fa-regular ${showFilterPanel ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                </Fragment>
            )}
        </div>
    )

    renderGuideAccordion = (showGuideAccordion, renderGuide) => (
        <Fragment>
            <div className="guide-accordion">
                <div
                    className="headerPPT"
                    onClick={this.toggleGuide}
                    aria-hidden
                >
                    <i className="fa-solid fa-circle-info" />
                    <p>Getting started guide</p>
                    <i className={`fa-light ${showGuideAccordion ? 'fa-square-chevron-up' : 'fa-square-chevron-down'}`} />
                </div>
                <AnimateHeight
                    className="guide-content"
                    duration={250}
                    height={showGuideAccordion ? 'auto' : 0}
                >
                    <hr className="divider" />
                    {renderGuide()}
                </AnimateHeight>
            </div>
        </Fragment>
    )

    renderResetBtn = (resetFilters) => (
        <div className="reset-wrapper-presentation" ref={this.resetWrapperRef}>
            <hr className="reset-divider" />
            <Button
                cssClass="reset-btn-presentation"
                icon="fa-regular fa-arrows-rotate"
                label={i18n.t('reset_filter', 'Reset filters')}
                onClick={resetFilters}
            />
        </div>
    )

    render() {
        const {
            pageTitle, renderFilterOptions, renderButtons,
            renderPresentationPanel, renderGuide, searchStore,
            hideFilterAccordion, surveyTitle, resetFilters,
        } = this.props
        const { showGuideAccordion, showFilterPanel, showBottomScroller } = this.state

        if (R.pathOr(false, ['searchLoading'], searchStore)) {
            return (
                <div
                    className="loader"
                    style={{
                        color: 'rgba(57,183,183, 1)',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                    }}
                />
            )
        }
        return (
            <div className="search-container presentation-container" ref={this.presentationPanelRef}>
                <div id="presentation-filter" className="left-container left-container-fixed">
                    <Panel cssClass="filter-panel-presentation left-panel-position" innerRef={this.leftPanelRef}>
                        {this.renderPageTitle(pageTitle, showFilterPanel, hideFilterAccordion)}

                        <div className={`scrollable-content ${showBottomScroller ? 'scroll' : ''}`} ref={this.scrollableDivRef}>
                            <div className="scrollable-wrapper" ref={this.scrollableWrapperRef}>
                                {renderGuide
                                    && this.renderGuideAccordion(showGuideAccordion, renderGuide)}
                                <AnimateHeight
                                    className="filter-wrapper"
                                    duration={250}
                                    height={showFilterPanel ? 'auto' : 0}
                                    contentClassName="filter-content"
                                >
                                    {renderFilterOptions()}
                                </AnimateHeight>
                                {this.renderResetBtn(resetFilters)}
                            </div>
                        </div>
                    </Panel>
                </div>
                <div className="right-container right-container-relative" ref={this.rightContainerRef}>
                    <Panel cssClass="upper-Panel">
                        <Panel cssClass="inner-panel">
                            {surveyTitle()}
                        </Panel>

                        <Panel cssClass="inner-panel button-panel">
                            <div className="search-panel-right">
                                {renderButtons()}
                            </div>
                        </Panel>
                    </Panel>
                    <div className="presentation-panel">
                        <div className="panel-inner-container position-absolute" ref={this.innerContainerRef}>
                            <Panel cssClass="table-panel" innerRef={this.tableRef}>

                                {renderPresentationPanel()}

                            </Panel>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PresentationLayout
